module.exports = __webpack_public_path__ + "img/img4.066255a8.jpg";